// extracted by mini-css-extract-plugin
export default {"inputGroup":"InputGroup__inputGroup--3ko","inputGroupLabel":"InputGroup__inputGroupLabel--VPk","inputContainer":"InputGroup__inputContainer--pi3"};